// LIBRARIES
import styled from "styled-components";
import Checkbox from "@mui/material/Checkbox";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const UserContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
  margin-top: 9px;
  margin-right: 20px;
`;

export const VerticalLine = styled.div`
  width: 4px;
  height: 50px;
  border-radius: 10px;
  background-image: linear-gradient(
    180deg,
    ${COLORS.veryPaleOrange} 0%,
    ${COLORS.terraCotta} 100%
  );
  margin-right: 22px;
`;

export const UserImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${COLORS.backgroundColor};
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

export const UserName = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  font-family: ${FONTS.newsharp};
  margin-bottom: 5px;
`;

export const UserStatus = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${FONTS.montserrat};
`;

export const Text = styled.text`
  font-size: 12px;
  color: ${COLORS.primaryGray};
  font-weight: 400;
  font-family: ${FONTS.montserrat};
`;
export const CheckboxContainer = styled(Checkbox)`
  && {
    padding: 0;
    margin-right: 10px;
    color: ${COLORS.primaryGray};
  }
`;
